import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
// import Zoom from 'react-reveal/Zoom';
// import Pulse from 'react-reveal/Pulse';
import config from 'config/api'
import Immutable from 'immutable';
import IconSetMenu from '../Icon/IconSetMenu';
// import IconFB from 'assets/images/facebook-box.svg';
// import IconLD from 'assets/images/linkedin-box.svg';
import IconFB from 'assets/images/icon_facebook.jpg';
import IconLD from 'assets/images/icon_linkedin.jpg';
import Jump from 'react-reveal/Jump';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button'
// import Flip from 'react-reveal/Flip';

const ANIMATION_LOOP = true;
class SectionIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerPosition: 50,
      containerHeight: '100%',
      showCircle: false,
      showLogo: false,
      showLogo0: false,
      showLogo1: false,
      showLogo2: false,
      showLogo3: false,
      showLogo4: false,
      showLogo5: false,
      showLogo6: false,
      showLogo7: false,
      showLogo8: false,
      showLogo9: false,
      showLogo10: false,
      showArrow: false,
      showBump: false,
    }
  }
  componentDidMount() {
    this.setState({
      containerHeight: window.innerHeight -  document.getElementById('header').offsetHeight,
      containerMargin: document.getElementById('header').offsetHeight
    });
    this._resetAnimations(this._animate.bind(this));
    // this._animate();
  }

  _resetAnimations(callback) {
    this.setState({
      showCircle: false,
      showLogo: false,
      showLogo0: false,
      showLogo1: false,
      showLogo2: false,
      showLogo3: false,
      showLogo4: false,
      showLogo5: false,
      showLogo6: false,
      showLogo7: false,
      showLogo8: false,
      showLogo9: false,
      showLogo10: false,
      showArrow: false,
      showBump: false,
    }, callback);
  }
  _animate() {

    const { $$data } = this.props;
    const timeOffset = 100;
    this._time = 0;

    const timelineMaxLength = 13000;

    const numbUnits = $$data.get(0).get('items').size;

    // let i=0;
    // let interval;

    const offset = 0;

    const decay = 300
    const pause = 1000;
    const refDelay = 1200;
    let delay;

    const timeline = {
      300: {
        showCircle: true,
      },
    };

    $$data.get(0).get('items').map((item, i) => {
      delay = refDelay*i+pause;
      timeline[offset+delay] = {
        ['showLogo'+i]: true
      }
      timeline[offset+decay+delay+pause] = {
        ['showLogo'+i]: false
      }
      // console.log('delay is', delay, i);
      return true;
    })

    timeline[offset+refDelay*numbUnits+pause] = {
      'showLogo': true
    }
    timeline[offset+refDelay*numbUnits+pause+refDelay] = {
      'showBump': true
    }
    timeline[offset+refDelay*numbUnits+pause+refDelay+4000] = {
      'showLogo': false
    }
    timeline[offset+refDelay*numbUnits+pause+refDelay+4000+1000] = {
      'showCircle': false
    }
    // timeline[offset+refDelay*numbUnits+pause+refDelay+500] = {
    //   ['showBump']: true
    // }

    // this.setState({running: true});
    // console.log('timeline is', timeline)
    this.$_interval = window.setInterval(function() {
      this._time = this._time + timeOffset

      if (timeline[this._time]) {
        // console.log('running ', this._time, timeline[this._time])
        this.setState(timeline[this._time]);

      } else if (this._time === timelineMaxLength) {
        // console.log('CLEANING !', this.$_interval)
        // clearInterval(this.$_interval);
        if (ANIMATION_LOOP) {
          this._resetAnimations(function() {
            this._time = 0;

          }.bind(this))
        } else {
          clearInterval(this.$_interval);
        }
        // console.log('CLEANING !', this.$_interval)
      } else if (this._time === timelineMaxLength + 200) {
        console.log('SHOULD NOT HAPPEN !')
      }
    }.bind(this), timeOffset)
  }
  componentWillUnmount() {
    if (this.$_interval)
    clearInterval(this.$_interval);
  }
  _onClick(e) {
    const id = 'recrutement';
    const top = document.getElementById(id) ? document.getElementById(id).offsetTop+10-document.getElementById('header').offsetHeight : false
    window.scroll({
      top,
      behavior: 'smooth'
    })
  }
  _getOffset() {
    const { width } = this.props;
    let offset;
    if (width === 'xs')
      offset = 5;
    else if (width === 'sm')
      offset = 10;
    else
      offset = 20;
    return offset;
  }
  _scrollBanner(e, direction) {
    const { bannerPosition } = this.state;
    let newPosition = bannerPosition;
    const offset = this._getOffset();
    if (direction === 'right') {
      // bannerPosition
      if (newPosition >= 100) {
        return;
      } else
        newPosition = newPosition + offset;
    }
    else if (direction === 'left') {
      // bannerPosition
      if (newPosition <= 0) {
        return;
      } else
        newPosition = newPosition - offset;
    }
    console.log({direction, bannerPosition})
    this.setState({bannerPosition: newPosition});
  }
  render() {
    const { $$data, width } = this.props;
    const divStyle = {
      width: '100%',
      height: this.state.containerHeight, ...(this.props.style || {}),
      marginTop: this.state.containerMargin
    };
    let images = [];
    $$data.get(0).get('items').map(i => {
      images.push(i.get('titleImage'))
      return true;
    });
    const $$images = Immutable.fromJS(images);

    const { bannerPosition } = this.state;
    // console.log(width)
    // console.log($$data.get(0).get('items').toJS())
    return (
      <section id="intro" className="SectionIntro" style={divStyle}>
        <div className="logos">
          <Fade duration={500} when={this.state.showCircle} opposite>
            <div className="placeholder"></div>
          </Fade>
          <Fade when={this.state.showLogo} duration={1000} opposite>
            <div className="logo"><img src={require('@assets/images/logo_big.png')} alt="Lobster" /></div>
          </Fade>
          {$$images.map((image, i) => {
            return <Fade key={'f_'+i} when={this.state['showLogo'+i]} opposite>
              <div className="logo"><img src={image} alt="Lobster" /></div>
            </Fade>

          }).toArray()}
        </div>
        <div className="banner" style={{backgroundPosition:  ''+bannerPosition+'% 50%'}}>
{/*            <Button className="left" onClick={(e) => {this._scrollBanner(e, 'left');}} >
            <IconSetMenu size={width === 'xs' ? 28 : 46} icon="chevron" iconButton={false}/>
            </Button>
            <Button className="right" onClick={(e) => {this._scrollBanner(e, 'right');}}>
              <IconSetMenu size={width === 'xs' ? 28 : 46} icon="chevron" iconButton={false} />
            </Button>
*/}
        </div>

        <div className="footer">
          <div className="bulletWrapper">
            <Jump duration={1000} when={this.state.showBump} count={2}>
              <Link to={'/#recruitment'} onClick={this._onClick.bind(this)} className="bullet"><IconSetMenu size={['xs', 'sm'].indexOf(width) >= 0 ? 28 : 56} icon="chevron" iconButton={false}/></Link>
            </Jump>
          </div>
        </div>
        <div className="social">
          <a href={config.fb} target="_blank">
            <img src={IconFB} alt="FB"/>
          </a>
          <a href={config.ld} target="_blank">
            <img src={IconLD} alt="LD"/>
          </a>
        </div>
      </section>
    );
  }
}

export default SectionIntro;



// WEBPACK FOOTER //
// ./src/components/Home/SectionIntro.jsx